import MembersList from './MembersList';
import WorkingGroupCRU from './WorkingGroupCRU';
export { MembersList, WorkingGroupCRU };

export const membersObj ={
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    designation: '',
    remarks: '',
}